import { useRef, useState } from 'preact/hooks';
import Stepper from '../../shared/Stepper/Stepper';
import Step from '../../shared/Stepper/Step';
import AppBar from '../../shared/AppBar/AppBar';
import FormStep1 from './FormSteps/Step1';
import FormStep2 from './FormSteps/Step2';
import FormStep3 from './FormSteps/Step3';
import FormStep4 from './FormSteps/Step4';
// import FormStep5 from './FormSteps/Step5';
import useAndroidBackPress from '../../../hooks/back.listener.hook';
import { TrackingEvent } from '../../../sdk/tracking.event';

const STEP_EVENTS = {
  0: FormStep1.EventName,
  1: FormStep2.EventName,
  2: FormStep3.EventName,
  3: FormStep4.EventName
  // 4: FormStep5.EventName,
};
export default function OnboardingEgyptLuckyV1({
                                                 onCloseClick,
                                                 onBackClick,
                                                 onFormSubmit,
                                                 data,
                                                 isPersonalized,
                                               }) {
  const [activeStep, setActiveStep] = useState(1);
  const [formData, setFormData] = useState(data);

  const backRef = useRef(null);

  const handleStepChange = e => {
    e.preventDefault();
    const stepEvent = STEP_EVENTS[activeStep - 1];
    TrackingEvent.trigger(
      TrackingEvent.Events.ONBOARDING_CONTINUE_BUTTON_TAP,
      TrackingEvent.Sources.CAAS,
      {
        step: stepEvent,
      },
    );
    setActiveStep(s => s + 1);
  };

  const handleInputChange = e => {
    setFormData(prevState => {
      const newState = { ...prevState };

      const currentKey = newState[e.target.name];

      if (!currentKey) {
        newState[e.target.name] = { value: e.target.value.trimStart() };
      } else {
        newState[e.target.name].value = e.target.value.trimStart();
      }
      return newState;
    });
  };

  const handleFormSubmit = e => {
    e.preventDefault();
    TrackingEvent.trigger(
      TrackingEvent.Events.ONBOARDING_CONTINUE_BUTTON_TAP,
      TrackingEvent.Sources.CAAS,
      {
        step: FormStep3.EventName,
      },
    );

    onFormSubmit(formData);
  };

  const handleBackClick = () => {
    const stepEvent = STEP_EVENTS[activeStep - 1];
    TrackingEvent.trigger(
      TrackingEvent.Events.ONBOARDING_BACK_TAP,
      TrackingEvent.Sources.CAAS,
      {
        step: stepEvent,
      },
    );
    if (activeStep > 1) {
      setActiveStep(s => s - 1);
    } else {
      onBackClick();
    }
  };

  useAndroidBackPress(backRef.current, () => {
    if (window.location.search.includes('popup')) {
      history.back();
    } else {
      backRef.current.props.onClick();
    }
  });

  return (
    <>
      <AppBar
        onCloseClick={onCloseClick}
        onBackClick={handleBackClick}
        backRef={backRef}
        className={`fixed-bar`}
      />

      <form onSubmit={handleFormSubmit}>
        <Stepper activeStep={activeStep}>
          <Step>
            <FormStep1
              onInputChange={handleInputChange}
              onButtonClick={handleStepChange}
              data={formData}
            />
          </Step>
          <Step>
            <FormStep2
              onInputChange={handleInputChange}
              onButtonClick={handleStepChange}
              data={formData}
              isPersonalized={isPersonalized}
            />
          </Step>
          <Step>
            <FormStep3
              onInputChange={handleInputChange}
              onButtonClick={handleStepChange}
              data={formData}
            />
          </Step>
          <Step>
            <FormStep4 onInputChange={handleInputChange} data={formData} />
          </Step>
          {/*<Step>*/}
          {/*  <FormStep4 onInputChange={handleInputChange} onButtonClick={handleStepChange} data={formData} />*/}
          {/*</Step>*/}
          {/*<Step>*/}
          {/*  <FormStep5 onInputChange={handleInputChange} data={formData} />*/}
          {/*</Step>*/}
        </Stepper>
      </form>
    </>
  );
}